import React, { SetStateAction, useState } from "react";
import { observer } from "mobx-react";

import { Button } from "@components/buttons";

import { OfferStoreContext } from "@gp/components";

import { BettingData } from "@data-types/sport-stats/SportStatsTypes";
import { EventKey, EventKeyBettingOffer } from "@gp/models";
import classnames from "classnames";
import { SportStatisticsTypeEnum } from "@data-types/analytics-tracker/SportsStatisticsInteractionTypeEnum";
import { analyticsTracker } from "@utils/analytics";

export default observer(function BettingTypeStatisticsButton(props: {
	bettingType: any;
	bettingTypeStats: BettingData[] | null;
	setBettingTypeStats: React.Dispatch<SetStateAction<BettingData[] | null>>;
	offerKey: { id: string }[] | EventKey;
}) {
	const offerStore = React.useContext(OfferStoreContext);
	const [isHover, setIsHover] = useState(false);
	const keyOffersMap = offerStore.keyOffersMap;

	//@ts-expect-error
	const keyOffers = keyOffersMap.get(props.offerKey.id);
	let offers: EventKeyBettingOffer[] = [];
	if (keyOffers != null) {
		offers = Array.from(keyOffers.values());
	}

	const playerIds = offers.map((offer) => offer.playerId);

	if (
		//@ts-expect-error
		!offerStore.sportStatisticsStore.availableBTypesSet.has(
			props.bettingType.abrv
		)
	) {
		if (props.bettingTypeStats) {
			props.setBettingTypeStats(null);
		}
		return null;
	}

	return (
		<Button
			className={classnames(
				"offer--additional__bet__stats btn btn--square btn--square--reset btn--ghost"
			)}
			onClick={async (e) => {
				e.preventDefault();
				e.stopPropagation();
				if (props.bettingTypeStats) {
					props.setBettingTypeStats(null);
					return;
				}
				analyticsTracker.trackSportStatisticsInteractionTracking(
					SportStatisticsTypeEnum.BettingTypeStatistics
				);
				const data =
					//@ts-expect-error
					await offerStore.sportStatisticsStore.fetchBettingStats(
						props.bettingType,
						props.offerKey,
						playerIds
					);
				props.setBettingTypeStats(data);
			}}
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			iconOnly
			iconClassName={classnames("u-icon u-icon--sml", {
				"u-icon--action--stats-additional--selected":
					props.bettingTypeStats,
				"u-icon--action--stats-additional--active":
					!props.bettingTypeStats && !isHover,
				"u-icon--action--stats-additional--selected u-color-text-tertiary":
					isHover,
			})}
		/>
	);
});
